import React from "react";
import { PublicHeader } from "./PublicHeader";
import { PublicFooter } from "./PublicFooter";

export function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-sambiva-cream flex flex-col">
      <PublicHeader />
      <main className="flex-1 pt-16 sm:pt-20">{children}</main>
      <PublicFooter />
    </div>
  );
}
